import React from 'react';
import { appVersion } from '../../config/AppVersion';

const Footer = () => {
  return (
    <footer
      className="footer d-flex justify-content-between align-items-center w-100 shadow-sm"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
        background: '#0b3383'
      }}
    >
      <div className="container d-flex justify-content-between align-items-center small">
        <p className="mb-0 flex-grow-1 text-center text-white">
         © {new Date().getFullYear()} AC Pública Sistemas. Todos os direitos reservados · {appVersion}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
